import { cn } from "@/lib/utils";

/** Dark-mode wash only. Safe on surfaces that already set a light-mode background. */
export const darkPageCanvasWashClassName =
  "dark:bg-slate-950 dark:[background-image:linear-gradient(90deg,rgba(147,51,245,0.07)_0%,transparent_42%),radial-gradient(circle_at_18%_20%,rgba(147,51,245,0.15),transparent_36%),radial-gradient(circle_at_84%_12%,rgba(63,146,255,0.12),transparent_34%)]";

/** Dark-mode page wash shared by New Review, New Draft, and global chat. */
export const darkPageCanvasBackgroundClassName = cn(
  "bg-transparent",
  darkPageCanvasWashClassName,
);
